import type React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

interface IntroductionSectionProps {
  title: string;
  subtitle: string;
}

const IntroductionSection: React.FC<IntroductionSectionProps> = ({
  title,
  subtitle,
}) => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          <div className="lg:w-1/2">
            <img
              src="/images/company/sinopec-lubricant-company-sg.jpg"
              alt="SINOPEC Lubricant Company"
              className="rounded-lg shadow-lg w-full max-h-[420px] object-cover"
            />
          </div>
          
          <div className="lg:w-1/2">
            <h2 className="text-3xl font-bold mb-6 relative inline-block">
              {title}
              <span className="absolute bottom-0 left-0 w-16 h-1 bg-red-600" style={{ marginBottom: "-8px" }}></span>
            </h2>
            
            <p className="text-gray-600 mb-6">
              {subtitle}
            </p>
            
            <Link
              to="/about"
              className="inline-flex items-center text-red-600 hover:text-red-700 font-medium transition-colors"
            >
              Learn more about Sinopec
              <ArrowRight size={16} className="ml-1" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroductionSection; 
